'use client';
import { baseLocale, type Locale } from '@bells/i18n/runtime';

import { createContext } from 'react';
export type LanguageContextProps = {
  language: Locale;
  setLanguage: (lang: Locale) => void;
};
export const LanguageContext = createContext<LanguageContextProps>({
  language: baseLocale,
  setLanguage: () => {},
});
